module.exports = "/_next/static/images/c52269e9035a4179a692444363dce3f3-nu-fifa-logo@2x.png";